export const SET_AUTO_PAY_ENABLED = 'SET_AUTO_PAY_ENABLED';